(function () {
    if ($('#wheels-form-requests-page').length) {
        // Toggle official GM address fields
        function toggleOfficialEmailFields() {
            let value = $('#official_email').val();

            if (value === 'yes') {
                $('#yes-fields').removeClass('d-none');
            } else {
                $('#yes-fields').addClass('d-none');
            }

            if (value === 'created') {
                $('#already-created-fields').removeClass('d-none');
            } else {
                $('#already-created-fields').addClass('d-none');
            }
        }

        toggleOfficialEmailFields();

        $('#official_email').on('change', function (e) {
            toggleOfficialEmailFields();
        });

        // Toggle static IP address fields
        function toggleStaticIpAddressFields() {
            let value = $('#is_user_restricted').val();

            if (value === 'yes') {
                $('#ip-addresses-list').show();
            } else {
                $('#ip-addresses-list').hide();
            }
        }

        toggleStaticIpAddressFields();

        $('#is_user_restricted').on('change', function (e) {
            toggleStaticIpAddressFields();
        });
    }
})();



// WEBPACK FOOTER //
// ./resources/scripts/portal/pages/wheels-form-requests.js